'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CompareBarComponent = CompareBarComponent;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = require('lodash');

var _bdcoreData = require('@bd/bdcore-data');

var _bdcoreData2 = _interopRequireDefault(_bdcoreData);

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _actions = require('@bd/bdcore-data/build/Compare/actions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CompareBarComponent(_ref) {
  var className = _ref.className,
      compare = _ref.compare,
      compareLinkProps = _ref.compareLinkProps,
      compareLinkRoute = _ref.compareLinkRoute,
      compareLinkText = _ref.compareLinkText,
      dispatch = _ref.dispatch,
      displayLimit = _ref.displayLimit,
      match = _ref.match,
      renderItem = _ref.renderItem;
  var _compare$items = compare.items,
      items = _compare$items === undefined ? [] : _compare$items,
      type = compare.type;

  return _react2.default.createElement(
    'div',
    { className: className + ' ' + (match.name !== compareLinkRoute && items.length ? 'CompareBar-active' : '') },
    _react2.default.createElement(
      'ul',
      { className: 'CompareBar_items' },
      items.slice(0, displayLimit).map(function (item) {
        return _react2.default.createElement(
          'li',
          { className: 'CompareBar_item', key: item._id },
          renderItem(type, item),
          _react2.default.createElement('span', {
            className: 'CompareBar_itemToggle',
            role: 'button',
            tabIndex: '0',
            onClick: function onClick() {
              return dispatch((0, _actions.toggleCompareItem)({ id: (0, _lodash.get)(item, '_id'), type: type }));
            }
          })
        );
      }),
      items.length > displayLimit && _react2.default.createElement(
        'li',
        { className: 'CompareBar_item CompareBar_item-count' },
        '+',
        items.length - displayLimit
      )
    ),
    _react2.default.createElement(
      'ul',
      { className: 'CompareBar_buttonList' },
      _react2.default.createElement(
        'li',
        { className: 'CompareBar_buttonListItem' },
        _react2.default.createElement(
          _bdcoreNamedRoutes.Link,
          Object.assign({ name: compareLinkRoute, className: 'CompareBar_button' }, compareLinkProps),
          compareLinkText
        )
      ),
      _react2.default.createElement(
        'li',
        { className: 'CompareBar_buttonListItem' },
        _react2.default.createElement(
          'span',
          {
            className: 'CompareBar_button',
            role: 'button',
            tabIndex: '0',
            onClick: function onClick() {
              return dispatch((0, _actions.cancelCompare)());
            }
          },
          'Cancel'
        )
      )
    )
  );
}

CompareBarComponent.propTypes = {
  className: _propTypes2.default.string,
  /** IGNORE: fetched from data automatically */
  compare: _propTypes2.default.shape({
    type: _propTypes2.default.string,
    items: _propTypes2.default.arrayOf(_propTypes2.default.object)
  }).isRequired,
  compareLinkProps: _propTypes2.default.object,
  compareLinkRoute: _propTypes2.default.string,
  compareLinkText: _propTypes2.default.string,
  dispatch: _propTypes2.default.func,
  displayLimit: _propTypes2.default.number,
  match: _propTypes2.default.object.isRequired,
  renderItem: _propTypes2.default.func
};

CompareBarComponent.defaultProps = {
  className: undefined,
  compareLinkProps: undefined,
  compareLinkRoute: 'compare',
  compareLinkText: 'Compare',
  dispatch: function dispatch() {},
  displayLimit: 3,
  renderItem: function renderItem(type, item, route) {
    return type + ': ' + item._id + ': ' + route;
  }
};

exports.default = (0, _bdcoreData2.default)({ compare: true })(CompareBarComponent);


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdui-compare/build/CompareBar.js
// module id = 1088
// module chunks = 0